export default __webpack_public_path__ + "static/media/cardio_splash.8f9362c6.jpg";